// Contrail V3.4.0 — "Admin" top-bar button with the unread notifications badge (admins only).
import { Link } from "react-router-dom";
import { useAdminUnread } from "../routes/admin/Notifications";

export default function AdminLink({ role }: { role: string | null | undefined }) {
  const unread = useAdminUnread(role === "skyward_admin");
  if (!role) return null;
  return (
    <Link className="btn-ghost admin-link" to={unread ? "/admin/activity" : "/admin"} title={unread ? `${unread} new admin notification${unread === 1 ? "" : "s"}` : undefined}>
      Admin{unread > 0 && <span className="badge">{unread > 99 ? "99+" : unread}</span>}
    </Link>
  );
}
